// DR-3B: decimalni zarez, tačka za hiljade, decimale po jedinici.
const brojac = new Intl.NumberFormat('sr-Latn-ME', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 3,
})

/** Količina iz domena `kolicina_t` stiže kao tekst (numeric), da se ne izgubi preciznost. */
export function kolicina(vrijednost: string | number | null): string {
  if (vrijednost === null || vrijednost === '') return '—'
  const broj = typeof vrijednost === 'string' ? Number(vrijednost) : vrijednost
  return Number.isFinite(broj) ? brojac.format(broj) : String(vrijednost)
}

/** Skraćenice nivoa pakovanja, kako stoje na etiketi. */
const skracenice: Record<string, string> = {
  komad: 'kom',
  kesa: 'kesa',
  karton: 'krt',
  paleta: 'pal',
}

export function nivoKratko(nivo: string): string {
  return skracenice[nivo] ?? nivo
}

/** Crnogorski oblici uz broj: 1 artikal, 2–4 artikla, 5+ artikala. */
export function oblikPoBroju(broj: number, jedan: string, dva: string, pet: string): string {
  const desetice = broj % 100
  if (desetice >= 11 && desetice <= 14) return pet
  switch (broj % 10) {
    case 1:
      return jedan
    case 2:
    case 3:
    case 4:
      return dva
    default:
      return pet
  }
}

/** Novčani iznos: uvijek dvije decimale, decimalni zarez, tačka za hiljade (DR-3B). */
const iznosac = new Intl.NumberFormat('sr-Latn-ME', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

export function iznos(vrijednost: string | number | null): string {
  if (vrijednost === null || vrijednost === '') return '—'
  const broj = typeof vrijednost === 'string' ? Number(vrijednost) : vrijednost
  return Number.isFinite(broj) ? iznosac.format(broj) : String(vrijednost)
}
